module.exports = ['$analytics', '$uibModal', countryHolidayModal];

function countryHolidayModal($analytics, $uibModal) {
    var modal = {
        show: showModal
    };

    countryHolidayModal.$inject = ['$uibModalInstance', 'holidayList'];

    function countryHolidayModal($uibModalInstance, holidayList) {
        var vm = {
            holidayList: holidayList,
            cancel: cancel
        };

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        return vm;
    }
    function showModal(holidayList) {
        var modalInstance = $uibModal.open({
            animation: true,
            backdrop: true,
            bindToController: true,
            controller: countryHolidayModal,
            controllerAs: 'ctrl',
            keyboard: true,
            modalFade: true,
            resolve: {
                holidayList: function () {
                    return holidayList;
                },
            },
            size: 'lg',
            templateUrl: 'customs-offices/modals/country-holiday-modal.html',
            windowClass: 'modal'
        });

        modalInstance.rendered.then(function() {
            var elementToFocusOnInModal = document.querySelector('.modal.in .focus-on-open-modal');
            if (elementToFocusOnInModal) {
                elementToFocusOnInModal.focus();
            }
        });

        return modalInstance;
    }

    return modal;
}